var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 23 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M11.3828 3.99781L18.9128 17.0078H3.85281L11.3828 3.99781ZM11.3828 0.0078125L0.382812 19.0078H22.3828L11.3828 0.0078125ZM12.3828 14.0078H10.3828V16.0078H12.3828V14.0078ZM12.3828 8.00781H10.3828V12.0078H12.3828V8.00781Z",
          fill: "#FF2525",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }